import {type List} from 'immutable';

import type FileRecord from 'web-app/react/components/file-upload/file-record';
import {useSelectorRef} from 'web-app/react/hooks/use-selector-ref';
import {type RootState} from 'web-app/react/redux/root-state';

import {isTaggableFile} from '../helpers';
import {useFileTaggingFormName} from './use-file-tagging-form-name';

export const useGetFiles = () => {
    const formName = useFileTaggingFormName();

    const files = useSelectorRef<RootState, List<FileRecord> | undefined>(state =>
        state.fileUpload.files.get(formName)?.filter(file => {
            return isTaggableFile(file);
        }),
    );

    return files;
};
